// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner-container-6FmTy","visible":"Spinner-visible-sYFtY","hidden":"Spinner-hidden-BzBG9","spinner":"Spinner-spinner-Vd3bJ","spin":"Spinner-spin-7C9rR"};